var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTituloMasCercano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "278px",
    height: "105px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdd6c7",
    d: "M -0.5,-0.5 C 92.1667,-0.5 184.833,-0.5 277.5,-0.5C 277.5,34.5 277.5,69.5 277.5,104.5C 184.833,104.5 92.1667,104.5 -0.5,104.5C -0.5,69.5 -0.5,34.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#604750",
    d: "M 66.5,47.5 C 66.44,46.9569 66.1067,46.6236 65.5,46.5C 64.5258,48.7427 64.1924,51.076 64.5,53.5C 62.3926,54.4682 60.0593,54.8016 57.5,54.5C 56.6192,39.5839 58.1192,24.9172 62,10.5C 63.6995,9.59391 65.5328,9.26057 67.5,9.5C 67.0941,18.174 66.9274,26.8406 67,35.5C 70.2026,31.8249 74.0359,29.6582 78.5,29C 80.0074,29.8373 80.5074,31.0039 80,32.5C 76.1542,35.0124 72.9876,38.1791 70.5,42C 73.2839,45.787 76.4506,49.287 80,52.5C 80.4828,53.448 80.6495,54.448 80.5,55.5C 78.09,56.0629 75.7567,56.5629 73.5,57C 71.0354,53.8927 68.7021,50.726 66.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#604750",
    d: "M 204.5,9.5 C 207.5,9.5 210.5,9.5 213.5,9.5C 212.715,18.2045 211.715,26.8712 210.5,35.5C 214.37,35.7512 218.37,35.7512 222.5,35.5C 223.001,42.8371 223.168,50.1704 223,57.5C 221.247,58.627 219.413,59.627 217.5,60.5C 216.909,54.7545 216.076,49.0879 215,43.5C 209.533,45.135 207.033,48.8017 207.5,54.5C 202.036,54.5969 199.703,51.9302 200.5,46.5C 201.835,34.1599 203.168,21.8266 204.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f464f",
    d: "M 8.5,17.5 C 15.175,17.3337 21.8417,17.5004 28.5,18C 33.7406,20.8769 34.9072,25.0436 32,30.5C 28.355,32.3371 28.0216,34.3371 31,36.5C 34.0992,43.5415 32.2659,48.7082 25.5,52C 20.4473,52.2174 15.4473,52.7174 10.5,53.5C 9.45737,41.519 8.7907,29.519 8.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#604650",
    d: "M 191.5,16.5 C 194.833,15.8333 196.833,17.1667 197.5,20.5C 194.837,22.9923 192.004,25.3256 189,27.5C 187.85,29.7538 187.516,32.0871 188,34.5C 190.039,36.8745 192.372,38.8745 195,40.5C 195.61,44.2364 195.277,47.9031 194,51.5C 190.99,53.1831 187.99,54.8498 185,56.5C 181.176,55.3909 177.343,54.3909 173.5,53.5C 173.5,51.5 173.5,49.5 173.5,47.5C 176.833,47.5 180.167,47.5 183.5,47.5C 183.66,45.8008 183.494,44.1341 183,42.5C 180.417,38.9131 178.25,35.0798 176.5,31C 177.9,26.8702 179.566,22.8702 181.5,19C 185.038,18.4652 188.372,17.6319 191.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#614750",
    d: "M 112.5,20.5 C 113.5,20.5 114.5,20.5 115.5,20.5C 115.337,22.8568 115.503,25.1902 116,27.5C 118.364,25.6372 120.864,23.9705 123.5,22.5C 126.167,24.5 128.5,26.8333 130.5,29.5C 129.764,31.5405 128.931,33.5405 128,35.5C 126.255,34.0443 124.422,32.711 122.5,31.5C 120.142,33.0243 118.309,35.0243 117,37.5C 115.838,43.1155 115.004,48.7822 114.5,54.5C 111.833,54.8333 109.167,55.1667 106.5,55.5C 105.637,44.8436 105.47,34.177 106,23.5C 108.166,22.2685 110.333,21.2685 112.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebc5b9",
    d: "M 15.5,25.5 C 28.7613,26.59 28.7613,28.2567 15.5,30.5C 15.5,28.8333 15.5,27.1667 15.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f454f",
    d: "M 248.5,25.5 C 250.5,25.5 252.5,25.5 254.5,25.5C 254.5,26.5 254.5,27.5 254.5,28.5C 259.357,28.8366 263.857,30.1699 268,32.5C 268.827,36.5411 268.66,40.5411 267.5,44.5C 263.805,47.3615 259.971,50.0282 256,52.5C 255.831,60.1883 255.331,67.8549 254.5,75.5C 252.677,74.2528 250.677,73.5861 248.5,73.5C 248.5,57.5 248.5,41.5 248.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f464f",
    d: "M 140.5,26.5 C 140.172,31.8746 140.505,37.2079 141.5,42.5C 142.833,41.8333 144.167,41.1667 145.5,40.5C 146.738,37.6165 148.072,34.7832 149.5,32C 151.818,31.6577 153.985,32.1577 156,33.5C 156.323,48.5256 155.823,63.5256 154.5,78.5C 153.167,78.5 151.833,78.5 150.5,78.5C 149.167,78.5 147.833,78.5 146.5,78.5C 146.827,69.3178 146.493,60.3178 145.5,51.5C 142.933,51.8545 140.433,52.5212 138,53.5C 135.127,52.1087 133.461,49.7754 133,46.5C 132.501,42.1794 132.334,37.8461 132.5,33.5C 133.468,31.3926 133.802,29.0593 133.5,26.5C 135.833,26.5 138.167,26.5 140.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#624851",
    d: "M 44.5,27.5 C 49.1997,27.7653 52.3664,30.0987 54,34.5C 54.651,40.8268 55.151,47.1601 55.5,53.5C 53.8333,53.5 52.1667,53.5 50.5,53.5C 50.6563,46.3419 49.323,45.5086 46.5,51C 43.8333,51.6667 41.1667,51.6667 38.5,51C 36.5475,47.6461 34.8809,44.1461 33.5,40.5C 36.8731,35.8038 40.5398,31.4704 44.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#614851",
    d: "M 93.5,26.5 C 102.459,26.7837 105.459,31.1171 102.5,39.5C 98.6733,41.246 95.0066,43.246 91.5,45.5C 94.4788,45.7533 97.4788,45.0867 100.5,43.5C 101.845,44.3467 102.845,45.5134 103.5,47C 100.056,49.8066 96.2229,51.9732 92,53.5C 85.698,51.5883 82.8647,47.255 83.5,40.5C 83.9297,33.603 87.263,28.9364 93.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#614851",
    d: "M 233.5,27.5 C 236.85,27.335 240.183,27.5017 243.5,28C 244,28.5 244.5,29 245,29.5C 245.667,36.1667 245.667,42.8333 245,49.5C 243.833,50.6667 242.667,51.8333 241.5,53C 237.167,53.6667 232.833,53.6667 228.5,53C 227.953,52.0754 227.287,51.2421 226.5,50.5C 225.336,44.5276 225.17,38.5276 226,32.5C 226.956,31.4214 227.789,30.2547 228.5,29C 230.382,28.8019 232.048,28.3019 233.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aa8a88",
    d: "M 140.5,26.5 C 138.167,26.5 135.833,26.5 133.5,26.5C 133.802,29.0593 133.468,31.3926 132.5,33.5C 132.5,30.8333 132.5,28.1667 132.5,25.5C 135.385,25.1936 138.052,25.5269 140.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8d2c4",
    d: "M 233.5,33.5 C 235.5,33.5 237.5,33.5 239.5,33.5C 239.5,37.1667 239.5,40.8333 239.5,44.5C 237.5,44.5 235.5,44.5 233.5,44.5C 233.5,40.8333 233.5,37.1667 233.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7d1c3",
    d: "M 44.5,34.5 C 45.8799,34.9623 46.5466,35.9623 46.5,37.5C 45.8631,40.1071 44.6965,42.4404 43,44.5C 41.5362,43.541 40.7028,42.2077 40.5,40.5C 41.4316,38.2345 42.7649,36.2345 44.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9c3b8",
    d: "M 93.5,35.5 C 95.5273,35.3379 97.5273,35.5045 99.5,36C 96.5815,37.7088 93.7482,39.5421 91,41.5C 90.4585,38.9175 91.2918,36.9175 93.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efc9bc",
    d: "M 256.5,35.5 C 257.833,35.5 259.167,35.5 260.5,35.5C 261.056,39.1928 259.722,41.8595 256.5,43.5C 255.271,40.8013 255.271,38.1346 256.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0cabe",
    d: "M 15.5,39.5 C 17.8568,39.3367 20.1902,39.5034 22.5,40C 23.6877,45.3255 21.3543,47.8255 15.5,47.5C 15.5,44.8333 15.5,42.1667 15.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9a96",
    d: "M 66.5,47.5 C 65.8333,49.5 65.1667,51.5 64.5,53.5C 64.1924,51.076 64.5258,48.7427 65.5,46.5C 66.1067,46.6236 66.44,46.9569 66.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a98a88",
    d: "M 145.5,51.5 C 146.493,60.3178 146.827,69.3178 146.5,78.5C 147.833,78.5 149.167,78.5 150.5,78.5C 149.081,79.4511 147.415,79.7845 145.5,79.5C 145.5,70.1667 145.5,60.8333 145.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#694f57",
    d: "M 77.5,85.5 C 78.4959,85.4142 79.3292,85.7476 80,86.5C 80.6667,88.5 81.3333,90.5 82,92.5C 83.9118,83.7406 86.5784,83.4073 90,91.5C 90.813,89.5643 91.313,87.5643 91.5,85.5C 92.675,85.281 93.675,85.6143 94.5,86.5C 93.0906,89.7268 92.0906,93.0601 91.5,96.5C 90.1779,96.67 89.0113,96.3366 88,95.5C 86.1291,87.7916 84.6291,88.125 83.5,96.5C 82.325,96.719 81.325,96.3857 80.5,95.5C 79.0906,92.2732 78.0906,88.9399 77.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a4f57",
    d: "M 103.5,85.5 C 106.572,85.1826 109.572,85.5159 112.5,86.5C 110.5,87.1667 108.5,87.8333 106.5,88.5C 113.049,90.0929 113.049,91.0929 106.5,91.5C 106.5,92.5 106.5,93.5 106.5,94.5C 108.604,94.2011 110.604,94.5344 112.5,95.5C 109.572,96.4841 106.572,96.8174 103.5,96.5C 103.5,92.8333 103.5,89.1667 103.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#684e56",
    d: "M 121.5,85.5 C 124.247,85.1866 126.914,85.52 129.5,86.5C 122.833,87.8333 122.833,89.1667 129.5,90.5C 127.955,91.4519 126.288,91.7852 124.5,91.5C 124.5,92.5 124.5,93.5 124.5,94.5C 126.604,94.2011 128.604,94.5344 130.5,95.5C 127.572,96.4841 124.572,96.8174 121.5,96.5C 121.5,92.8333 121.5,89.1667 121.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#684e56",
    d: "M 138.5,85.5 C 141.572,85.1826 144.572,85.5159 147.5,86.5C 146.675,87.3857 145.675,87.719 144.5,87.5C 144.5,90.5 144.5,93.5 144.5,96.5C 143.5,96.5 142.5,96.5 141.5,96.5C 141.5,93.5 141.5,90.5 141.5,87.5C 139.821,87.7148 138.821,87.0481 138.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#614851",
    d: "M 168.5,85.5 C 171.187,85.3359 173.854,85.5026 176.5,86C 179.978,88.7065 180.311,91.7065 177.5,95C 174.649,96.2886 171.649,96.7886 168.5,96.5C 168.5,92.8333 168.5,89.1667 168.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#664c54",
    d: "M 61.5,85.5 C 69.9653,85.63 70.2986,86.63 62.5,88.5C 64.1792,89.782 66.0126,90.782 68,91.5C 68.7203,93.1124 68.5536,94.6124 67.5,96C 64.6213,96.8736 61.9546,96.5403 59.5,95C 60,94.5 60.5,94 61,93.5C 62.8138,94.7596 64.6471,94.7596 66.5,93.5C 64.6136,92.5937 62.7803,91.5937 61,90.5C 60.3603,88.735 60.5269,87.0683 61.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0cabe",
    d: "M 170.5,87.5 C 176.158,86.6794 177.825,88.846 175.5,94C 173.866,94.4935 172.199,94.6602 170.5,94.5C 170.5,92.1667 170.5,89.8333 170.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b5158",
    d: "M 191.5,85.5 C 192.978,85.238 194.311,85.5713 195.5,86.5C 197.396,89.8271 198.396,93.1605 198.5,96.5C 195.372,93.9 192.205,93.9 189,96.5C 188.5,96.1667 188,95.8333 187.5,95.5C 189.406,92.36 190.74,89.0266 191.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#644b53",
    d: "M 207.5,85.5 C 209.729,86.0553 211.395,87.3886 212.5,89.5C 213.382,88.2402 214.382,87.0736 215.5,86C 216.332,85.3123 216.998,85.479 217.5,86.5C 214.944,89.3893 213.277,92.7227 212.5,96.5C 211.082,92.6671 209.415,89.0005 207.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c19f9a",
    d: "M 192.5,88.5 C 194.121,88.7869 195.121,89.7869 195.5,91.5C 194.675,92.3857 193.675,92.719 192.5,92.5C 192.5,91.1667 192.5,89.8333 192.5,88.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTituloMasCercano);
export default __webpack_public_path__ + "static/media/titulo-mas-cercano.671478ff8c72b9b55e45c78b7515d184.svg";
export { ForwardRef as ReactComponent };